import { createListenerMiddleware, createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Org, OrgRoleType, User } from '@/lib/api';

import type { AuthState } from './types';

const initialState: AuthState = {
    loading: true,
    authenticated: false,
};

export const listenerMiddleware = createListenerMiddleware();

export const { actions, reducer } = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        init(state) {
            state.loading = true;
        },

        login(state, { payload: { accessToken } }: PayloadAction<{ accessToken: string; refreshToken: string }>) {
            state.token = accessToken;
            state.loading = true;
            state.authenticated = true;
        },

        logout(state) {
            state.user = undefined;
            state.authenticated = false;
            state.loading = false;
        },

        preauth(state) {
            state.user = undefined;
            state.token = undefined;
            state.authenticated = false;
            state.loading = false;
        },

        authenticated(state, { payload: { token } }: PayloadAction<{ token: string }>) {
            state.token = token;
            state.loading = false;
            state.authenticated = true;
        },

        authComplete(
            state,
            {
                payload: { org, role, user },
            }: PayloadAction<{ user: User | undefined; org: Org | undefined; role: OrgRoleType | undefined }>
        ) {
            state.user = user;
            state.org = org;
            state.role = role;
            state.loading = false;
        },

        acceptTerms(state, { payload: { user } }: PayloadAction<{ user: User }>) {
            state.user = user;
        },
    },
});
